export const Colors = {
    sienna: '#953c3d',
    snow: '#fef7f7',
    dimgray: '#595959',
    fee: '#ffd8d9'
}
